const filterTitles = document.querySelectorAll('.filter-title');
filterTitles.forEach((filterTitle) => {
	filterTitle.addEventListener('click', (elem) => {
		elem.target.parentNode.classList.toggle('open');
	});
});
